import * as mapService from '@api/map';
import { GenericLocationItem } from '@api/map/types';
import * as rolesService from '@api/person/designation';
import { ColoredChipIconButton } from '@components/colored-elements';
import { ScrollSpyMuiTabs } from '@components/mui/tabs';
import { ScrollSpyBoundry } from '@components/scroll-spy';
import { TrashFill } from '@icon/react-icons';
import SocialMediaIcon from '@icon/social-media';
import { convertToDateTimeFromISOString, createControlField } from '@lib/common';
import * as personManagementApi from '@api/person-management';
import {
  attributeOptionsFromMaster,
  ClassificationField,
  ClassificationOption,
  PersonMaster,
} from '@lib/person-management';
import {
  AppBar,
  Box,
  Button,
  Checkbox,
  Chip,
  Divider,
  FormControl,
  FormControlLabel,
  Grid,
  GridSize,
  IconButton,
  InputAdornment,
  InputLabel,
  makeStyles,
  MenuItem,
  Radio,
  RadioGroup,
  Select,
  Tab,
  TextField,
  Tooltip,
  Typography,
} from '@material-ui/core';
import CircularProgress, { CircularProgressProps } from '@material-ui/core/CircularProgress';
import { amber, blue, green, indigo, lime, orange, purple, red } from '@material-ui/core/colors';
import Fab from '@material-ui/core/Fab';
import { createStyles, Theme } from '@material-ui/core/styles';
import AccountTreeTwoToneIcon from '@material-ui/icons/AccountTreeTwoTone';
import AddIcon from '@material-ui/icons/Add';
import BallotRoundedIcon from '@material-ui/icons/BallotRounded';
import ClearIcon from '@material-ui/icons/Clear';
import ContactMailRoundedIcon from '@material-ui/icons/ContactMailRounded';
import ContactsIcon from '@material-ui/icons/Contacts';
import DescriptionRoundedIcon from '@material-ui/icons/DescriptionRounded';
import HttpIcon from '@material-ui/icons/Http';
import { Autocomplete } from '@material-ui/lab';
import { debounce, startCase } from 'lodash';
import { SectionTitle, SubSectionTitle } from 'pages/company/form/common';
import { CompanyBadgesField, CompanyBasicFormField, createTextAttr } from 'pages/company/form/fields';
import { CommonCellForCompanyLogo } from 'pages/company/search/columns/utils';
import { COUNTRY_INFO } from 'pages/constants';
import React, { useCallback, useEffect, useRef, useState } from 'react';
import { Controller, useController, useFieldArray, useFormContext } from 'react-hook-form';
import { Subscription } from 'rxjs';
import { catchError, map, tap } from 'rxjs/operators';
import styled from 'styled-components';
import { PersonPosterField } from './person-logo';
import { ControlledHiddenField, DynamicIdsSection, mapApiToForm, OriginCountryField, parsePersonName, useDynamicIds } from './utils';
import { DatePicker } from '@material-ui/pickers';
import { AddCircleOutline, DeleteOutline } from '@material-ui/icons';
import { format } from 'path';
import PersonMediaSection from './person-media';

const sectionIcon = <AccountTreeTwoToneIcon fontSize="large" style={{ color: orange[600] }} />;

const CityAutoCompleteEvent = ({ value, onChange }) => {
  const classesForAvatarImage = useStyles();
  const lastSubscription = useRef<Subscription>(null);
  const lastSearchedvalue = useRef<string>(null);

  const [open, setOpen] = React.useState(false);
  const [options, setOptions] = React.useState([]);
  const [loading, setLoading] = React.useState(false);
  const [personCount, setPersonCount] = React.useState(null);
  const [filmingLocations, setFilmingLocations] = React.useState([]);
  const [defaultLocation, setDefaultLocation] = React.useState(null);
  const [activeItem, setActiveItem] = React.useState<GenericLocationItem>(defaultLocation);
  const onChangeHandle = useCallback(value => {
    onChange(value);
    if (lastSearchedvalue.current && lastSearchedvalue.current == value && options.length > 0) {
      setOptions(prevOptions => [...prevOptions]);
      return;
    }
    setOptions([]);
    lastSearchedvalue.current = value;
    if (lastSubscription.current) {
      lastSubscription.current.unsubscribe();
    }
    setLoading(true);
    // let query = 'Mumbai'
    lastSubscription.current = mapService
      .filmingLocationIqSearch(value)
      .pipe(
        tap(r => (r[0] ? setActiveItem(r[0]) : null)),
        catchError(err =>
          [400, 404].includes(err?.response?.status)
            ? Promise.reject(`No Results found for '${err?.config?.params?.q}'`)
            : Promise.reject(`${err}`)
        )
      )
      .subscribe({
        next: data => {
          const dt = data
            ?.filter(opt => {
              if (opt?.type === 'city') {
                return true;
              }
            })
            ?.map(dt => {
              return dt?.city;
            });
          const optSet = new Set(dt);
          setOptions(Array.from(optSet) ?? []);
        },
        error: data => {
          console.error(data, 'Error');
        },
        complete: () => {
          setLoading(false);
        },
      });
  }, []);

  const debouncedOnChangeHandle = useCallback(
    debounce(value => onChangeHandle(value), 2000),
    [onChangeHandle]
  );

  return (
    <>
      <Autocomplete
        fullWidth
        // multiple
        open={open}
        onOpen={() => {
          setOpen(true);
        }}
        onClose={() => {
          setOpen(false);
        }}
        getOptionLabel={option => {
          return option;
        }}
        options={options}
        renderTags={(tagValue, getTagProps) => {
          return tagValue.map((option, index) => (
            <Chip label={option} {...getTagProps({ index })} color="secondary" />
          ));
        }}
        renderOption={option => (
          <Grid container alignItems="center">
            <Grid item xs={12}>
              {option}
            </Grid>
          </Grid>
        )}
        loading={loading}
        loadingText={'Searching ... '}
        value={value}
        onChange={(evt, v) => onChange && onChange(v)}
        renderInput={props => (
          <TextField
            label={'City'}
            placeholder={'Select Location'}
            fullWidth
            value={value}
            variant="outlined"
            {...props}
            onChange={ev => {
              if (!!ev.target.value) {
                debouncedOnChangeHandle(ev.target.value);
              }
            }}
            onFocus={ev => {
              if (!!ev.target.value) {
                debouncedOnChangeHandle(ev.target.value);
              }
            }}
            InputProps={{
              ...props.InputProps,
              endAdornment: (
                <React.Fragment>
                  {loading ? (
                    <>
                      <CircularProgress color="inherit" size={20} />
                      {props.InputProps.endAdornment}
                    </>
                  ) : value ? (
                    <>{props.InputProps.endAdornment}</>
                  ) : null}
                </React.Fragment>
              ),
            }}
          />
        )}
      />
    </>
  );
};

export const CityLocationField = createControlField(CityAutoCompleteEvent, []);

const useStylesPhoneInput = makeStyles(theme => ({
  formControl: {
    width: '100%',
  },
  textField: {
    '& .MuiInputBase-root': {
      paddingRight: 0, // Remove default padding to align with dropdown
    },
  },
  select: {
    marginRight: theme.spacing(1), // Add some space between dropdown and input
  },
}));

const socialAttrs = [createTextAttr('source_urls', 'Source URL', 'Addtional Source URLs')];

const StyledFab = styled(Fab)`
  &.MuiFab-sizeSmall {
    width: 40px;
    // height: 30px;
  }
  & .MuiSvgIcon-root {
    font-size: 1.4rem;
  }
`;

function PhoneInput({ value, onChange }) {
  const classes = useStylesPhoneInput();
  const [country, setCountry] = useState(value ? value?.split('-')[0] : '+1');
  const [phoneNumber, setPhoneNumber] = useState(value ? value?.split('-')[1] : '');

  const handleCountryChange = event => {
    setCountry(event.target.value);
  };

  const handlePhoneNumberChange = event => {
    setPhoneNumber(event.target.value);
  };

  useEffect(() => {
    if (value) {
      setPhoneNumber(value ? value?.split('-')[1] : '');
      setCountry(value ? value?.split('-')[0] : '+1');
    }
  }, [value]);

  useEffect(() => {
    if (phoneNumber) {
      const phone_num = country + '-' + phoneNumber;
      onChange(phone_num);
    }
  }, [country, phoneNumber]);

  return (
    <FormControl className={classes.formControl}>
      <TextField
        id="phone-input"
        variant="outlined"
        fullWidth
        label="Phone Number"
        value={phoneNumber}
        placeholder="Phone Number"
        onChange={handlePhoneNumberChange}
        InputProps={{
          type: 'number',
          startAdornment: (
            <InputAdornment position="start">
              <Select
                className={classes.select}
                value={country}
                onChange={handleCountryChange}
                labelId="country-select-label"
                id="country-select"
                disableUnderline // Remove underline from Select
                MenuProps={{
                  anchorOrigin: {
                    vertical: 'bottom',
                    horizontal: 'left',
                  },
                  transformOrigin: {
                    vertical: 'top',
                    horizontal: 'left',
                  },
                  getContentAnchorEl: null,
                }}>
                {COUNTRY_INFO.map(country => (
                  <MenuItem key={country.dial_code} value={country.dial_code}>
                    {country?.name}
                  </MenuItem>
                ))}
              </Select>
              -
            </InputAdornment>
          ),
        }}
        className={classes.textField}
      />
    </FormControl>
  );
}

export const PhoneInputField = createControlField(PhoneInput, '');

const DateField = createControlField(props => (
  <DatePicker
    fullWidth
    clearable
    style={{ marginTop: 0, marginBottom: 0 }}
    inputVariant="outlined"
    views={['year', 'month', 'date']}
    format={'MMM d, yyyy'}
    margin="normal"
    size="small"
    {...props}
  />
));

interface PrimaryOption {
  label: string;
  value: boolean; // true = primary, false = secondary
}

const primaryOptions: PrimaryOption[] = [
  { label: "Primary", value: true },
  { label: "Secondary", value: false },
];

interface PrimarySelectProps {
  value: boolean;
  onChange: (val: boolean) => void;
  label?: string;
}
export const PrimarySelect = ({
  name,
  form,
  index,
  disabled = false,
}: {
  name: string;
  form: any;
  index: number;
  disabled:boolean;
}) => {
  const {
    field: { value, onChange },
  } = useController({
    name,
    control: form.control,
     // defaultValue: false, // VERY IMPORTANT
  });
const emails = form.watch("emails") || []
  const selectedOption =
    primaryOptions.find(opt => opt.value === value) ??
    primaryOptions[1];
  return (
    <Autocomplete
      fullWidth
      disableClearable
      disabled={disabled}
      options={primaryOptions}
      getOptionLabel={(option) => option.label}
      getOptionSelected={(option, val) =>
        option.value === val.value
      }
      value={selectedOption}
      onChange={(_, selectedOption: PrimaryOption) => {
        if (!selectedOption) return;

        const isPrimary = selectedOption.value;

        if (isPrimary) {
        /*   // Make this one primary, others false
          const currentEmails = form.getValues("emails") || []; */

          emails.forEach((_, idx) => {
            form.setValue(
              `emails.${idx}.is_primary`,
              idx === index,
              { shouldDirty: true }
            );
          });
        } else {
          // Prevent removing last primary
          const currentEmails = form.getValues("emails") || [];
          const primaryCount = currentEmails.filter(
            e => e.is_primary
          ).length;

          if (primaryCount === 1) return;

          onChange(false);
        }
      }}
      renderInput={(params) => (
        <TextField
          {...params}
          label="Email Type"
          variant="outlined"
        />
      )}
    />
  );
};

interface Props {
 form: any;
  name: string;
  label: string;
  disabled?: boolean;
  defaultValue?: boolean | null;
}
const EMAIL_STATUS_OPTIONS = [
  { label: 'Verified', value: 'VERIFIED' },
  { label: 'Opted Out', value: 'OPT_OUT' },
  { label: 'Hard Bounce', value: 'HARD_BOUNCE' },
  { label: 'Soft Bounce', value: 'SOFT_BOUNCE' },
  { label: 'Unsubscribed', value: 'UNSUBSCRIBED' },
];
export const EmailTypeField = ({
  name,
  label,
  form,
  disabled = false,
}: Props) => {
  const {
    field: { value, onChange },
  } = useController({
    name,
    control: form.control,
  });

  return (
    <FormControl fullWidth disabled={disabled}>
      <InputLabel shrink>{label}</InputLabel>

      <Select
        native
        value={
          value === true
            ? 'true'
            : value === false
            ? 'false'
            : ''
        }
        onChange={e => {
          const v = e.target.value;
          onChange(v === '' ? null : v === 'true');
        }}
      >
        <option value="">Select</option>
        <option value="true">Yes</option>
        <option value="false">No</option>
      </Select>
    </FormControl>
  );
};

export const EmailStatusDropdown = ({
  name,
  label,
  form,
  disabled = false,
}: Props) => {
  const {
    field: { value, onChange },
  } = useController({
    name,
    control:form.control,
  });

  return (
    <FormControl fullWidth disabled={disabled}>
      <InputLabel shrink>{label}</InputLabel>

      <Select
        native
        value={value ?? ''}
        onChange={e => onChange(e.target.value)}
      >
        <option value="">Select</option>
        {EMAIL_STATUS_OPTIONS.map(opt => (
          <option key={opt.value} value={opt.value}>
            {opt.label}
          </option>
        ))}
      </Select>
    </FormControl>
  );
};

const CLASSIFICATION_FIELDS: Array<[ClassificationField, string]> = [
  ['seniority', 'Seniority'],
  ['seniority_level', 'Seniority Level'],
  ['persona', 'Persona'],
  ['detailed_persona', 'Detailed Persona'],
];

const EMPTY_CLASSIFICATION_OPTIONS: Record<ClassificationField, ClassificationOption[]> = {
  seniority: [],
  seniority_level: [],
  persona: [],
  detailed_persona: [],
};

const classificationIdName = (field: ClassificationField) => `${field}_id`;

const ClassificationSelect = styled(Select)`
  && .MuiInputBase-input {
    padding: 6px;
    padding-right: 32px;
  }
`;

const PersonOptionField = ({ name, label, options, form, loading }) => {
  const {
    field: { value, onChange },
  } = useController({ name, control: form.control });

  return (
    <div>
      <Typography variant="h6" gutterBottom>
        {label}
      </Typography>
      <FormControl fullWidth>
        <ClassificationSelect
          fullWidth
          displayEmpty
          disabled={loading}
          value={loading ? '' : value ?? ''}
          onChange={event => onChange(event.target.value || null)}
          renderValue={selected => {
            if (loading) return 'Loading...';
            if (!selected) return 'Select';
            return options.find(option => option.id === selected)?.label || 'Select';
          }}
          IconComponent={
            loading
              ? () => (
                  <CircularProgress
                    size={16}
                    style={{ position: 'absolute', right: 10, pointerEvents: 'none' }}
                  />
                )
              : undefined
          }
          MenuProps={{
            getContentAnchorEl: null,
            anchorOrigin: { vertical: 'bottom', horizontal: 'left' },
            transformOrigin: { vertical: 'top', horizontal: 'left' },
            PaperProps: { style: { maxHeight: 280 } },
          }}
        >
          <MenuItem value="">Select</MenuItem>
          {options
            .filter(option => !option.deprecated)
            .map(option => (
              <MenuItem key={option.id} value={option.id}>
                {option.label}
              </MenuItem>
            ))}
        </ClassificationSelect>
      </FormControl>
    </div>
  );
};

const PersonClassificationFields = ({ form }: { form: any }) => {
  const { field } = useController({
    name: 'do_not_sell_information',
    control: form.control,
  });
  const [loading, setLoading] = useState(true);
  const [optionsByField, setOptionsByField] = useState(EMPTY_CLASSIFICATION_OPTIONS);

  useEffect(() => {
    const subscription = personManagementApi.searchAttributeMaster(1, 100).subscribe({
      next: response => {
        setOptionsByField(attributeOptionsFromMaster(response));
        setLoading(false);
      },
      error: () => setLoading(false),
    });
    return () => subscription.unsubscribe();
  }, []);

  useEffect(() => {
    if (loading) return;
    CLASSIFICATION_FIELDS.forEach(([fieldName]) => {
      const idName = classificationIdName(fieldName);
      const current = form.getValues(idName);
      if (!current) return;
      const options = optionsByField[fieldName] || [];
      if (options.some(option => option.id === current)) return;
      const match = options.find(
        option => option.label.toLowerCase() === String(current).trim().toLowerCase(),
      );
      if (match) form.setValue(idName, match.id);
      else form.setValue(idName, null);
    });
  }, [loading, optionsByField, form.watch('seniority_id'), form.watch('seniority_level_id'), form.watch('persona_id'), form.watch('detailed_persona_id')]);

  return (
    <Grid item xs={12}>
      <Typography variant="h6" gutterBottom>
        Please do not sell my information
      </Typography>
      <RadioGroup
        row
        value={field.value === true ? 'yes' : field.value === false ? 'no' : ''}
        onChange={event => field.onChange(event.target.value === 'yes')}
      >
        <FormControlLabel value="yes" control={<Radio color="primary" />} label="Yes" />
        <FormControlLabel value="no" control={<Radio color="primary" />} label="No" />
      </RadioGroup>
      <br/>
      <div
        style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))',
          gap: 16,
        }}
      >
        {CLASSIFICATION_FIELDS.map(([name, label]) => (
          <PersonOptionField
            key={name}
            form={form}
            loading={loading}
            name={classificationIdName(name)}
            label={label}
            options={optionsByField[name] || []}
          />
        ))}
      </div>
      <br/>
    </Grid>
  );
};

export function PersonMasterRelationForm({ personMasterData, createPersonMaster = false,setDeletedIds ,actions}) {
  const { control } = useFormContext();
  const form = useFormContext();
  const profileSecRef = useRef();
  const contactDetailsSecRef = useRef();
  const externalProfilesSecRef = useRef(null);
  const c2pRelRef = useRef(null);
  const sourcesSecRef = useRef(null);
  const specializationSecRef = useRef(null);
  const personMediaRef = useRef<HTMLDivElement>(null);
  const badgeSecRef = useRef<HTMLDivElement>(null);
  const watchOnOtherSourceUrl = form.watch('source_urls');
  useEffect(() => {  
  if (!personMasterData) return;
  if (!personMasterData?.emails?.length) return;

  form.reset({
    ...form.getValues(), // keep other form values
    emails: form.getValues('emails'),
    tmdb_ids: personMasterData.tmdb_ids || [],
    imdb_ids: personMasterData.imdb_ids || [],
    hubspot_ids: personMasterData.hubspot_ids || [],
    do_not_sell_information: personMasterData.do_not_sell_information ?? null,
    seniority_id: personMasterData.seniority_id ?? personMasterData.seniority ?? null,
    seniority_level_id: personMasterData.seniority_level_id ?? personMasterData.seniority_level ?? null,
    persona_id: personMasterData.persona_id ?? personMasterData.persona ?? null,
    detailed_persona_id: personMasterData.detailed_persona_id ?? personMasterData.detailed_persona ?? null,
  });
}, [personMasterData]);
const sourceUrlsArray = Array.isArray(personMasterData?.source_urls)
  ? personMasterData.source_urls
  : typeof personMasterData?.source_urls === 'string'
    ? personMasterData.source_urls.split(',').filter(Boolean)
    : [];
  const initialNumberofUrls = sourceUrlsArray.length || 1;
  const [indexesAttributes, setIndexesAttributes] = useState(
    Array.from(Array(initialNumberofUrls || 1), (_, i) => i)
  );

  const [counterAttributes, setCounterAttributes] = useState(initialNumberofUrls || 1);

  const addAttributes = useCallback(() => {
    setIndexesAttributes(prevIndexes => {
      return [...prevIndexes, counterAttributes];
    });
    setCounterAttributes(prevCounter => prevCounter + 1);
  }, [indexesAttributes, counterAttributes]);

  const removeAttributes = useCallback(index => {
    setIndexesAttributes(prevIndexes => {
      return [...prevIndexes.filter(item => item !== index)];
    });
  }, []);

  const { fields, append, remove } = useFieldArray({
  control: form.control,
    name: 'emails',
  });

const handleDelete = (index: number) => {
  if (fields.length === 1) {
    // Track deleted vtr_id if exists
    removeEmail(index, fields);

    // Replace existing row with clean empty row
    form.setValue(`emails.${index}`, {
      email_id: '',
      email_status: "NULL",
      is_email_generic: null,
      is_email_personal: null,
      is_primary: true,
      vtr_id: null,
    });

    return;
  }

  // More than one email → normal removal
  removeEmail(index, fields);
  remove(index);

  // Ensure at least one primary remains
  const remainingEmails = form.getValues("emails");
  const hasPrimary = remainingEmails?.some(e => e?.is_primary);

  if (!hasPrimary && remainingEmails?.length > 0) {
    form.setValue(`emails.0.is_primary`, true);
  }
};

const {
  fields: hubspotFields,
  append: appendHubspot,
  remove: removeHubspot,
} = useFieldArray({
  control: form.control,
  name: "hubspot_ids",
});
const {
  fields: tmdbFields,
  append: appendTMDB,
  remove: removeTMDB,
} = useFieldArray({
  control: form.control,
  name: "tmdb_ids",
});

const {
  fields: imdbFields,
  append: appendIMDB,
  remove: removeIMDB,
} = useFieldArray({
  control: form.control,
  name: "imdb_ids",
});
const emailArray = Array.isArray(personMasterData?.emails)
  ? personMasterData.emails
  : [];

const {
  indexes: emailIndexes,
  add: addEmail,
  remove: removeEmail,
  deletedVtrIds: deletedEmailVtrIds
} = useDynamicIds(emailArray);
const tmdbArray = personMasterData?.tmdb_ids || [];
const {
  indexes: tmdbIndexes,
  add: addTmdb,
  remove: removeTmdb,
  deletedVtrIds: deletedTmdb
} = useDynamicIds(tmdbArray);

const imdbArray = personMasterData?.imdb_ids || [];
const {
  indexes: imdbIndexes,
  add: addImdb,
  remove: removeImdb,
  deletedVtrIds: deletedImdb
} = useDynamicIds(imdbArray);

const hubspotArray = personMasterData?.hubspot_ids || [];
const {
  indexes: hubspotIndexes,
  add: addHubspot,
  remove: removehubspot,
  deletedVtrIds: deletedHubspot
} = useDynamicIds(hubspotArray);
useEffect(() => {
//console.log(personMasterData)
}, [personMasterData]);

useEffect(() => {
  setDeletedIds(prev => ({
    ...prev,
    tmdb_id: deletedTmdb,
    imdb_id: deletedImdb,
    hubspot_id: deletedHubspot,
    email_id:deletedEmailVtrIds,
  }));
}, [deletedTmdb, deletedImdb, deletedHubspot, setDeletedIds]);

  const handleClick = ref => {
    ref.current?.scrollIntoView({ behavior: 'smooth' });
  };
 //console.log('📦 Final Payload:', form.getValues());
  const hasC2PRelations =
    personMasterData && personMasterData?.companies && personMasterData?.companies?.length > 0;
  return (
    <div>
      <ScrollSpyBoundry defaultItem="profile">
        <AppBar color="secondary" style={{ position: 'sticky', top: 64, background: purple[800] }}>
          <Grid container alignItems="center" spacing={1}  justify="space-between" >
            <Grid item>
              <ScrollSpyMuiTabs $small>
                <Tab onClick={() => handleClick(profileSecRef)} value="profile" label="PROFILE" />
                <Tab
                  onClick={() => handleClick(contactDetailsSecRef)}
                  value="contact-details"
                  label="CONTACT DETAILS"
                />
                <Tab
                  onClick={() => handleClick(externalProfilesSecRef)}
                  value="external-profiles"
                  label="EXTERNAL PROFILES"
                />
                {hasC2PRelations && (
                  <Tab
                    onClick={() => handleClick(c2pRelRef)}
                    value="c2p-relations"
                    label="C2P RELATIONS"
                  />
                )}
                {!createPersonMaster && (
                  <Tab
                    onClick={() => handleClick(personMediaRef)}
                    value="person-media"
                    label="MEDIA"
                  />
                )}
                <Tab onClick={() => handleClick(badgeSecRef)} value="badges" label="BADGES" />
                <Tab onClick={() => handleClick(sourcesSecRef)} value="sources" label="SOURCES" />
                <Tab
                  onClick={() => handleClick(specializationSecRef)}
                  value="specialization"
                  label="SPECIALISATION"
                />
              </ScrollSpyMuiTabs>
            </Grid>
            <Grid item style={{display:'flex'}}>
              {!createPersonMaster && (
                <Tooltip title="Create Company Person relation">
                  <div
                    style={{
                      margin: '0 15px 0 10px',
                      height: '36px',
                      backgroundColor: 'orange',
                      padding: '9px 10px',
                      borderRadius: '4px',
                      color: 'white',
                      cursor: 'pointer',
                      whiteSpace:"nowrap"
                    }}
                    onClick={() =>
                      window.open(
                        `/company-person/add?person_vtr_id=${personMasterData.vtr_id}&person_name=${encodeURIComponent(personMasterData.name)}`,
                      )
                    }>
                    Create C2P
                  </div>
                </Tooltip>
              )}
                {actions}
            </Grid>
          {/*   <Grid item>
             
            </Grid> */}
          </Grid>
        </AppBar>
        {personMasterData.vtr_id ? (
          <>
            <Grid>
              <br />
              <br />
              <div ref={profileSecRef}  style={{ scrollMarginTop: '120px' }}></div>
              <SectionTitle
                id="profile"
                title="Profiles"
                subTitle=""
                icon={<BallotRoundedIcon style={{ color: indigo[700] }} fontSize="large" />}
              />
              <br />
            </Grid>
            <Grid container spacing={1}>
              <Grid item xs={2}>
                <PersonPosterField control={control} name="poster" />
              </Grid>
              <Grid container xs={10} spacing={1}>
                <Grid item xs={4}>
                  <Typography variant="h6" gutterBottom>
                    First Name<span style={{ color: 'red' }}>*</span>
                  </Typography>
                  <ControlledTextField
                    fullWidth
                    variant="outlined"
                    name={'firstname'}
                    label={'First Name'}
                    control={form.control}
                    defaultValue={personMasterData.firstname ? personMasterData.firstname : ''}
                  />
                </Grid>
                <br />
                <br />
                <Grid item xs={4}>
                  <Typography variant="h6" gutterBottom>
                    Middle Name
                  </Typography>
                  <ControlledTextField
                    fullWidth
                    variant="outlined"
                    name={'middlename'}
                    label={'Middle Name'}
                    control={form.control}
                    defaultValue={
                      personMasterData.middlename !== null ? personMasterData.middlename : ''
                    }
                  />
                </Grid>
                <br />
                <br />
                <Grid item xs={4}>
                  <Typography variant="h6" gutterBottom>
                    Last Name
                  </Typography>
                  <ControlledTextField
                    fullWidth
                    variant="outlined"
                    name={'lastname'}
                    label={'Last Name'}
                    control={form.control}
                    defaultValue={personMasterData.lastname ? personMasterData.lastname : ''}
                  />
                </Grid>
                <br />
                <br />
                <Grid item xs={3}>
                  <Typography variant="h6" gutterBottom>
                    Known For
                  </Typography>
                  <ControlledAutoCompleteField
                    // fullWidth
                    variant="outlined"
                    name={'role_id'}
                    label={'Known for'}
                    control={form.control}
                    defaultValue={personMasterData.role_id ? personMasterData.role_id : ''}
                  />
                </Grid>
                <br />
                <br />
                <Grid item xs={9}>
                  <Typography variant="h6" gutterBottom>
                    AKA
                  </Typography>
                  <ControlledTextField
                    fullWidth
                    variant="outlined"
                    name={'aka'}
                    label={'AKA'}
                    control={form.control}
                    defaultValue={personMasterData?.aka ? personMasterData?.aka : ''}
                  />
                </Grid>
                <br />
                <br />
                <Grid item xs={3}>
                  <Typography variant="h6" gutterBottom>
                    Date of Death
                  </Typography>
                  <DateField
                    control={control}
                    name="death_day"
                    label="Date of Death"
                    helperText="The date of this person's demise."
                  />
                </Grid>
                <br />
                <br />
                <Grid item xs={3}>
                  <Typography variant="h6" gutterBottom>
                    Adult
                  </Typography>
                  <Select
                    name="adult"
                    inputRef={form.register}
                    style={{ width: '100px' }}
                    native
                    label="Adult"
                    defaultValue={personMasterData?.adult ? personMasterData?.adult : ''}>
                    <option value="">Select</option>
                    <option value="1">Yes</option>
                    <option value="0">No</option>
                  </Select>
                </Grid>
                <br />
                <br />
              </Grid>
              <Grid>
                <br />
                <br />
                <div ref={contactDetailsSecRef}  style={{ scrollMarginTop: '120px' }}></div>
                <SectionTitle
                  id="contact-details"
                  title="Contact Details"
                  subTitle=""
                  icon={<ContactMailRoundedIcon style={{ color: lime[700] }} fontSize="large" />}
                />
                <br />
              </Grid>
              <Grid container spacing={1}>
                {/* Emails Section */}
                {
                  <Grid item xs={12}>
                    <Grid container alignItems="center" justify="space-between">
                      <Typography variant="h6" gutterBottom>
                        Email IDs
                      </Typography>

                      <IconButton
                        onClick={() => {
                          addEmail();
                          append({
                            email_id: '',
                            email_status: null,
                            is_email_generic: null,
                            is_email_personal: null,
                            is_primary: fields.length === 0, // first only
                            vtr_id: null,
                          });
                        }}
                        aria-label="add"
                        style={{ color: 'blue' }}>
                        <AddCircleOutline fontSize="large" />
                      </IconButton>
                    </Grid>
                    {emailIndexes.map(index => {
                      const emailValue = form.watch(`emails.${index}.email_id`);
                      const disabled = !emailValue;

                      return (
                        <Grid key={index} container spacing={2} alignItems="center">
                          <Grid item xs={2}>
                            <ControlledTextField
                              control={form.control}
                              name={`emails.${index}.email_id`}
                              label="Email ID"
                              fullWidth
                            />
                          </Grid>

                          <Grid item xs={2}>
                            <EmailStatusDropdown
                              form={form}
                              name={`emails.${index}.email_status`}
                              disabled={disabled}
                              label={'Email Status'}
                            />
                          </Grid>

                          <Grid item xs={2}>
                            <EmailTypeField
                              form={form}
                              name={`emails.${index}.is_email_personal`}
                              disabled={disabled}
                              label="Personal"
                            />
                          </Grid>

                          <Grid item xs={2}>
                            <EmailTypeField
                              form={form}
                              name={`emails.${index}.is_email_generic`}
                              disabled={disabled}
                              label={'Generic'}
                            />
                          </Grid>

                          <Grid item xs={2}>
                            <PrimarySelect
                              name={`emails.${index}.is_primary`}
                              form={form}
                              index={index}
                              disabled={disabled}
                            />
                            <ControlledHiddenField
                              name={`emails.${index}.vtr_id`}
                              control={control}
                            />
                          </Grid>

                          <Grid item xs={2}>
                            <ColoredChipIconButton
                              onClick={() => handleDelete(index)}
                              icon={<TrashFill />}
                              pointer
                              colored={red[900]}
                              size="small"
                            />
                          </Grid>
                        </Grid>
                      );
                    })}
                    <br />
                  </Grid>
                }
                <PersonClassificationFields form={form} />
                {/* Location, Country, Phone stay separate */}
                <Grid item xs={3}>
                  <Typography variant="h6" gutterBottom>
                    Location City
                  </Typography>
                  <CityLocationField control={form.control} name="location_city" />
                </Grid>
                <Grid item xs={3}>
                  <Typography variant="h6" gutterBottom>
                    Location Country
                  </Typography>
                  <OriginCountryField control={form.control} name="location_country" />
                </Grid>
                <Grid item xs={4}>
                  <Typography variant="h6" gutterBottom>
                    Phone Number
                  </Typography>
                  <PhoneInputField control={form.control} name="phone_number" />
                </Grid>
              </Grid>
              <Grid>
                <br />
                <br />
                <div ref={externalProfilesSecRef}  style={{ scrollMarginTop: '120px' }}></div>
                <SectionTitle
                  id="external-profiles"
                  title="External Profiles"
                  subTitle=""
                  icon={<SocialMediaIcon height={'2.1875rem'} width={'2.1875rem'} />}
                />
                <br />
              </Grid>
              <Grid container xs={12} spacing={1}>
                <Grid item xs={12}>
                  <DynamicIdsSection
                    title=" TMDB Person IDs"
                    fieldName="tmdb_ids"
                    idKey="tmdb_id"
                    dataArray={tmdbArray}
                    indexes={tmdbIndexes}
                    add={addTmdb}
                    remove={removeTmdb}
                    labelPrimary={'Primary TMDB Person ID'}
                    labelSecondary={'TMDB Person ID'}
                    control={control}
                  />
                </Grid>
                <Grid item xs={12}>
                  <DynamicIdsSection
                    title=" IMDB Person IDs"
                    fieldName="imdb_ids"
                    idKey="imdb_id"
                    dataArray={imdbArray}
                    indexes={imdbIndexes}
                    add={addImdb}
                    remove={removeImdb}
                    labelPrimary={'Primary IMDB Person ID'}
                    labelSecondary={'IMDB Person ID'}
                    control={control}
                  />
                </Grid>
                <Grid item xs={12}>
                  <DynamicIdsSection
                    title=" HubSpot IDs"
                    fieldName="hubspot_ids"
                    idKey="hubspot_id"
                    dataArray={hubspotArray}
                    indexes={hubspotIndexes}
                    add={addHubspot}
                    remove={removehubspot}
                    labelPrimary={'Primary HubSpot ID'}
                    labelSecondary={'HubSpot ID'}
                    control={control}
                  />
                </Grid>
                <Grid item xs={6}>
                  <Typography variant="h6" gutterBottom>
                    LinkedIn URL
                  </Typography>
                  {/* <ControlledAutoCompleteFieldForServiceAKA */}
                  <ControlledTextField
                    fullWidth
                    variant="outlined"
                    name={'linkedin_url'}
                    label={'LinkedIn URL'}
                    control={form.control}
                    defaultValue={
                      personMasterData?.linkedin_url ? personMasterData?.linkedin_url : ''
                    }
                  />
                </Grid>
                <br />
                <br />
                <Grid item xs={6}>
                  <Typography variant="h6" gutterBottom>
                    Instagram URL
                  </Typography>
                  {/* <ControlledAutoCompleteFieldForServiceAKA */}
                  <ControlledTextField
                    fullWidth
                    variant="outlined"
                    name={'instagram_url'}
                    label={'Instagram URL'}
                    control={form.control}
                    defaultValue={
                      personMasterData?.instagram_url ? personMasterData?.instagram_url : ''
                    }
                  />
                </Grid>
                <br />
                <br />
                <Grid item xs={6}>
                  <Typography variant="h6" gutterBottom>
                    Facebook URL
                  </Typography>
                  {/* <ControlledAutoCompleteFieldForServiceAKA */}
                  <ControlledTextField
                    fullWidth
                    variant="outlined"
                    name={'facebook_url'}
                    label={'Facebook URL'}
                    control={form.control}
                    defaultValue={
                      personMasterData?.facebook_url ? personMasterData?.facebook_url : ''
                    }
                  />
                </Grid>
                <br />
                <br />
                <Grid item xs={6}>
                  <Typography variant="h6" gutterBottom>
                    X/Twitter URL
                  </Typography>
                  {/* <ControlledAutoCompleteFieldForServiceAKA */}
                  <ControlledTextField
                    fullWidth
                    variant="outlined"
                    name={'twitter_url'}
                    label={'Twitter URL'}
                    control={form.control}
                    defaultValue={
                      personMasterData?.twitter_url ? personMasterData?.twitter_url : ''
                    }
                  />
                </Grid>
                <br />
                <br />
                <Grid item xs={4}>
                  <Typography variant="h6" gutterBottom>
                    Home Page
                  </Typography>
                  <ControlledTextField
                    fullWidth
                    variant="outlined"
                    name={'home_page'}
                    label={'Home Page'}
                    control={form.control}
                    defaultValue={personMasterData?.home_page ? personMasterData?.home_page : ''}
                  />
                </Grid>
                <br />
                <br />
                <Grid item xs={4}>
                  <Typography variant="h6" gutterBottom>
                    Freebase
                  </Typography>
                  <ControlledTextField
                    fullWidth
                    variant="outlined"
                    name={'freebase_id'}
                    label={'Freebase'}
                    control={form.control}
                    defaultValue={personMasterData?.freebase ? personMasterData?.freebase : ''}
                  />
                </Grid>
                <br />
                <br />
                <Grid item xs={4}>
                  <Typography variant="h6" gutterBottom>
                    TV Rage
                  </Typography>
                  <ControlledTextField
                    fullWidth
                    variant="outlined"
                    name={'tvrage_id'}
                    label={'TV Rage'}
                    control={form.control}
                    defaultValue={personMasterData?.tv_rage ? personMasterData?.tv_rage : ''}
                  />
                </Grid>
                <br />
                <br />
                <Grid item xs={4}>
                  <Typography variant="h6" gutterBottom>
                    Wikidata
                  </Typography>
                  <ControlledTextField
                    fullWidth
                    variant="outlined"
                    name={'wikidata_id'}
                    label={'Wikidata'}
                    control={form.control}
                    defaultValue={personMasterData?.wikidata ? personMasterData?.wikidata : ''}
                  />
                </Grid>
                <br />
                <br />
                <Grid item xs={4}>
                  <Typography variant="h6" gutterBottom>
                    TikTok
                  </Typography>
                  <ControlledTextField
                    fullWidth
                    variant="outlined"
                    name={'tiktok_url'}
                    label={'TikTok'}
                    control={form.control}
                    defaultValue={personMasterData?.tikTok ? personMasterData?.tikTok : ''}
                  />
                </Grid>
                <br />
                <br />
                <Grid item xs={4}>
                  <Typography variant="h6" gutterBottom>
                    YouTube
                  </Typography>
                  <ControlledTextField
                    fullWidth
                    variant="outlined"
                    name={'youtube_url'}
                    label={'YouTube'}
                    control={form.control}
                    defaultValue={personMasterData?.youTube ? personMasterData?.youTube : ''}
                  />
                </Grid>
                <br />
                <br />
                <br />
              </Grid>
              {hasC2PRelations && (
                <>
                  <Grid>
                    <br />
                    <br />
                    <div ref={c2pRelRef}  style={{ scrollMarginTop: '120px' }}></div>
                    <SectionTitle
                      id="external-profiles"
                      title="Company Person Relations"
                      subTitle=""
                      icon={<ContactsIcon fontSize="large" style={{ color: blue[600] }} />}
                    />
                    <br />
                  </Grid>
                  <Grid container xs={12} spacing={1}>
                    <C2PTable data={personMasterData?.companies} />
                  </Grid>
                </>
              )}
              <Grid container spacing={1}>
                <Grid item xs={12}>
                  {!createPersonMaster && (
                    <div ref={personMediaRef}  style={{ scrollMarginTop: '120px' }}>
                      <PersonMediaSection personVtrId={personMasterData?.vtr_id} />
                    </div>
                  )}
                </Grid>
              </Grid>
              <Grid item xs={12}>
                <br />
                <br />
                <div ref={badgeSecRef}  style={{ scrollMarginTop: '120px' }}>
 <Grid item>
          <SectionTitle
            id="person-badges"
            title="Person Badges"
            subTitle="Information about Person Badges"
            icon={sectionIcon}
          />
        </Grid>
         <Divider />
              <br />
              <Grid container spacing={1}>
                <Grid item xs={12}>
                  <CompanyBadgesField control={control} name="person_badges" isLock={false} />
                </Grid>
              </Grid>
                </div>
              </Grid>
              <Grid item xs={12}>
                <br />
                <br />
                <div ref={sourcesSecRef}  style={{ scrollMarginTop: '120px' }}></div>
                <SectionTitle
                  id="sources"
                  title="Sources"
                  subTitle=""
                  icon={<AccountTreeTwoToneIcon fontSize="large" style={{ color: green[600] }} />}
                />
                <br />
                <br />
              </Grid>
              <Grid container xs={12} spacing={1}>
                <Grid item style={{ width: '15%' }}>
                  <Typography variant="h6" gutterBottom>
                    Sources
                  </Typography>
                  <ControlledSourceTextField
                    disabled
                    fullWidth
                    variant="outlined"
                    name={'datasource_id'}
                    label={'Source'}
                    control={form.control}
                    defaultValue={
                      personMasterData?.datasource_id ? personMasterData?.datasource_id : ''
                    }
                  />
                </Grid>
                <Grid item style={{ width: '15%' }}>
                  <Typography variant="h6" gutterBottom>
                    Dataowner
                  </Typography>
                  <ControlledDataOwnerTextField
                    disabled
                    fullWidth
                    variant="outlined"
                    name={'dataowner_id'}
                    label={'Dataowner'}
                    control={form.control}
                    defaultValue={
                      personMasterData?.dataowner_id ? personMasterData?.dataowner_id : ''
                    }
                  />
                </Grid>
                <Grid item style={{ width: '15%' }}>
                  <Typography variant="h6" gutterBottom>
                    Status
                  </Typography>
                  <ControlledStatusSelect
                    fullWidth
                    variant="outlined"
                    name={'is_deleted'}
                    label={'Status'}
                    control={form.control}
                    defaultValue={personMasterData?.is_deleted ? true : false}
                  />
                </Grid>
                <Grid item xs>
                  <Typography variant="h6" gutterBottom>
                    Created On
                  </Typography>
                  <DateControlledTextField
                    disabled
                    fullWidth
                    variant="outlined"
                    name={'created_at'}
                    label={'Created At'}
                    control={form.control}
                    defaultValue={personMasterData?.created_at ?? ''}
                  />
                </Grid>
                <Grid item xs>
                  <Typography variant="h6" gutterBottom>
                    Modified On
                  </Typography>
                  <DateControlledTextField
                    fullWidth
                    disabled
                    variant="outlined"
                    name={'modified_at'}
                    label={'Modified On'}
                    control={form.control}
                    defaultValue={personMasterData?.modified_at ?? ''}
                  />
                </Grid>
                <Grid item xs>
                  <Typography variant="h6" gutterBottom>
                    Modified By
                  </Typography>
                  <ControlledTextField
                    fullWidth
                    disabled
                    variant="outlined"
                    name={'updated_by'}
                    label={'Modified By'}
                    control={form.control}
                    defaultValue={
                      personMasterData?.updated_by ? personMasterData?.updated_by : null
                    }
                  />
                </Grid>
                <Grid item xs={12}>
                  <br />
                  <br />
                  <Grid container justify="space-between" style={{ marginRight: '30px' }}>
                    <Grid item>
                      <SubSectionTitle
                        icon={
                          <HttpIcon
                            fontSize="large"
                            style={{
                              color: '#9be026',
                              background:
                                'radial-gradient(square, rgba(2,0,36,1) 55%, rgba(255,255,255,1) 55%, rgba(255,255,255,1) 100%)',
                            }}
                          />
                        }
                        title="Source URLs"
                        subTitle="Additional URLs of sources"
                      />
                    </Grid>
                    <Grid item style={{ paddingBottom: '10px' }}>
                      <Tooltip title="Add IMDb details">
                        <StyledFab
                          disabled={false}
                          onClick={addAttributes}
                          color="primary"
                          aria-label="add"
                          size="small">
                          <AddIcon />
                        </StyledFab>
                      </Tooltip>
                    </Grid>
                  </Grid>
                  <Divider />
                  <br />
                  <fieldset disabled={false} style={{ border: 'none' }}>
                    <Grid
                      container
                      spacing={1}
                      justify="space-between"
                      // style={{ display: 'flex' }}
                      // key={indexOfAttribute}
                    >
                      {indexesAttributes.map((indexOfAttribute, i) => {
                        return socialAttrs.map((attr, i) => {
                          return (
                            <Grid
                              item
                              container
                              style={{ display: 'flex' }}
                              xs={6}
                              key={indexOfAttribute}>
                              <Grid item xs={10}>
                                <CompanyBasicFormField
                                  {...attr}
                                  fullWidth
                                  name={`source_urls[${indexOfAttribute}]`}
                                  defaultValue={
                                    watchOnOtherSourceUrl
                                      ? watchOnOtherSourceUrl[indexOfAttribute]
                                      : ''
                                  }
                                />
                              </Grid>
                              {indexesAttributes.length > 1 ? (
                                <Grid item xs={2}>
                                  <div
                                    style={{
                                      marginTop: '10px',
                                      justifyContent: 'center',
                                      display: 'flex',
                                      marginRight: '20px',
                                    }}>
                                    <Tooltip title="Delete Atrribute">
                                      <ColoredChipIconButton
                                        onClick={() => removeAttributes(indexOfAttribute)}
                                        pointer
                                        colored={red[900]}
                                        size="small"
                                        icon={<TrashFill />}
                                      />
                                    </Tooltip>
                                  </div>
                                </Grid>
                              ) : null}
                            </Grid>
                          );
                        });
                      })}
                    </Grid>
                  </fieldset>
                </Grid>
              </Grid>
              <Grid>
                <br />
                <br />
                <div ref={specializationSecRef}  style={{ scrollMarginTop: '120px' }}></div>
                <SectionTitle
                  id="specialization"
                  title="Specialization"
                  subTitle=""
                  icon={<DescriptionRoundedIcon fontSize="large" style={{ color: amber[700] }} />}
                />
                <br />
              </Grid>
              <Grid container xs={12} spacing={1}>
                <Grid item xs={3}>
                  <Typography variant="h6" gutterBottom>
                    Popularity
                  </Typography>
                  <ControlledTextField
                    disabled
                    fullWidth
                    variant="outlined"
                    name={'popularity'}
                    label={'Popularity'}
                    control={form.control}
                    defaultValue={personMasterData?.popularity ? personMasterData?.popularity : ''}
                  />
                </Grid>
                <Grid item xs={12}>
                  <Typography variant="h6" gutterBottom>
                    Headline
                  </Typography>
                  <ControlledTextField
                    fullWidth
                    variant="outlined"
                    name={'headline'}
                    label={'Headline'}
                    control={form.control}
                    defaultValue={personMasterData?.headline ? personMasterData?.headline : ''}
                    multiline
                    rows={3}
                  />
                </Grid>
                <Grid item xs={12}>
                  <Typography variant="h6" gutterBottom>
                    Expertise
                  </Typography>
                  <ControlledTextField
                    fullWidth
                    variant="outlined"
                    name={'expertise'}
                    label={'Expertise'}
                    control={form.control}
                    defaultValue={personMasterData?.expertise ? personMasterData?.expertise : ''}
                    multiline
                    rows={3}
                  />
                </Grid>
                <Grid item xs={12}>
                  <Typography variant="h6" gutterBottom>
                    Biography
                  </Typography>
                  <ControlledTextField
                    fullWidth
                    variant="outlined"
                    name={'biography'}
                    label={'Biography'}
                    control={form.control}
                    defaultValue={personMasterData?.biography ? personMasterData?.biography : ''}
                    multiline
                    rows={8}
                  />
                </Grid>
              </Grid>
            </Grid>
          </>
        ) : (
          (createPersonMaster || true) && (
            <>
              <Grid>
                <br />
                <br />
                <div ref={profileSecRef}  style={{ scrollMarginTop: '120px' }}></div>
                <SectionTitle
                  id="profile"
                  title="Profiles"
                  subTitle=""
                  icon={<BallotRoundedIcon style={{ color: indigo[700] }} fontSize="large" />}
                />
                <br />
              </Grid>
              <Grid container spacing={1}>
                <Grid item xs={2}>
                  <PersonPosterField control={control} name="poster" />
                </Grid>
                <Grid container xs={10} spacing={1}>
                  <Grid item xs={4}>
                    <Typography variant="h6" gutterBottom>
                      First Name<span style={{ color: 'red' }}>*</span>
                    </Typography>
                    <ControlledTextField
                      fullWidth
                      variant="outlined"
                      name={'firstname'}
                      label={'First Name'}
                      control={form.control}
                      defaultValue={''}
                    />
                  </Grid>
                  <br />
                  <br />
                  <Grid item xs={4}>
                    <Typography variant="h6" gutterBottom>
                      Middle Name
                    </Typography>
                    {/* <ControlledAutoCompleteFieldForServiceAKA */}
                    <ControlledTextField
                      fullWidth
                      variant="outlined"
                      name={'middlename'}
                      label={'Middle Name'}
                      control={form.control}
                      defaultValue={''}
                    />
                  </Grid>
                  <br />
                  <br />
                  <Grid item xs={4}>
                    <Typography variant="h6" gutterBottom>
                      Last Name
                    </Typography>
                    <ControlledTextField
                      fullWidth
                      variant="outlined"
                      name={'lastname'}
                      label={'Last Name'}
                      control={form.control}
                      defaultValue={''}
                    />
                  </Grid>
                  <br />
                  <br />
                  <Grid item xs={3}>
                    <Typography variant="h6" gutterBottom>
                      Known For
                    </Typography>
                    <ControlledAutoCompleteField
                      // fullWidth
                      variant="outlined"
                      name={'role_id'}
                      label={'Known for'}
                      control={form.control}
                      defaultValue={''}
                    />
                  </Grid>
                  <br />
                  <br />
                  <Grid item xs={9}>
                    <Typography variant="h6" gutterBottom>
                      AKA
                    </Typography>
                    <ControlledTextField
                      fullWidth
                      variant="outlined"
                      name={'aka'}
                      label={'AKA'}
                      control={form.control}
                      defaultValue={''}
                    />
                  </Grid>
                  <br />
                  <br />
                  <Grid item xs={3}>
                    <Typography variant="h6" gutterBottom>
                      Date of Death
                    </Typography>
                    <DateField
                      control={control}
                      name="death_day"
                      label="Date of Death"
                      helperText="The date of this person's demise."
                    />
                  </Grid>
                  <br />
                  <br />
                  <Grid item xs={3}>
                    <Typography variant="h6" gutterBottom>
                      Adult
                    </Typography>
                    <Select
                      name="adult"
                      inputRef={form.register}
                      style={{ width: '100px' }}
                      native
                      label="Adult"
                      defaultValue={personMasterData?.adult ? personMasterData?.adult : ''}>
                      <option value="">Select</option>
                      <option value="1">Yes</option>
                      <option value="0">No</option>
                    </Select>
                  </Grid>
                  <br />
                  <br />
                </Grid>
                <Grid>
                  <br />
                  <br />
                  <div ref={contactDetailsSecRef}  style={{ scrollMarginTop: '120px' }}></div>
                  <SectionTitle
                    id="contact-details"
                    title="Contact Details"
                    subTitle=""
                    icon={<ContactMailRoundedIcon style={{ color: lime[700] }} fontSize="large" />}
                  />
                  <br />
                </Grid>
                <Grid container spacing={1}>
                  {
                    <Grid item xs={12}>
                      <Grid container alignItems="center" justify="space-between">
                        <Typography variant="h6" gutterBottom>
                          Email IDs
                        </Typography>

                        <IconButton
                          onClick={() => {
                            append({
                              email_id: '',
                              email_status: null,
                              is_email_generic: null,
                              is_email_personal: null,
                              is_primary: fields.length === 0, // first only
                            });
                          }}
                          aria-label="add"
                          style={{ color: 'blue' }}>
                          <AddCircleOutline fontSize="large" />
                        </IconButton>
                      </Grid>

                      {fields.map((field, index) => {
                        const canDelete = fields.length > 1;
                        const emailValue = form.watch(`emails.${index}.email_id`);
                        const disabled = !emailValue;
                        return (
                          <Grid
                            key={field.id}
                            container
                            spacing={2}
                            alignItems="center"
                            style={{
                              marginTop: 1,
                              padding: 2,
                              borderRadius: 1,
                            }}>
                            {/* Email */}
                            <Grid item xs={2}>
                              <ControlledTextField
                                control={form.control}
                                name={`emails.${index}.email_id`}
                                label="Email ID"
                                fullWidth
                                variant="outlined"
                              />
                            </Grid>

                            {/* Status */}
                            <Grid item xs={2}>
                              <EmailStatusDropdown
                                form={form}
                                name={`emails.${index}.email_status`}
                                label="Email Status"
                                disabled={disabled}
                              />
                            </Grid>

                            {/* Personal */}
                            <Grid item xs={2}>
                              <EmailTypeField
                                form={form}
                                name={`emails.${index}.is_email_personal`}
                                label="Personal"
                                disabled={disabled}
                              />
                            </Grid>

                            {/* Generic */}
                            <Grid item xs={2}>
                              <EmailTypeField
                                form={form}
                                name={`emails.${index}.is_email_generic`}
                                label="Generic"
                                disabled={disabled}
                              />
                            </Grid>
                            <Grid item xs={2}>
                              <PrimarySelect
                                name={`emails.${index}.is_primary`}
                                form={form}
                                index={index}
                                disabled={disabled}
                              />
                            </Grid>
                            {/* Delete */}
                            <Grid item xs={2}>
                              {canDelete && (
                                <Tooltip title="Delete email">
                                  <ColoredChipIconButton
                                    onClick={() => handleDelete(index)}
                                    pointer
                                    colored={red[900]}
                                    size="small"
                                    icon={<TrashFill />}
                                  />
                                </Tooltip>
                              )}
                            </Grid>
                          </Grid>
                        );
                      })}
                      <br />
                    </Grid>
                  }
                  <PersonClassificationFields form={form} />

                  {/* Location, Country, Phone stay separate */}
                  <Grid item xs={3}>
                    <Typography variant="h6" gutterBottom>
                      Location City
                    </Typography>
                    <CityLocationField control={form.control} name="location_city" />
                  </Grid>
                  <Grid item xs={3}>
                    <Typography variant="h6" gutterBottom>
                      Location Country
                    </Typography>
                    <OriginCountryField control={form.control} name="location_country" />
                  </Grid>
                  <Grid item xs={4}>
                    <Typography variant="h6" gutterBottom>
                      Phone Number
                    </Typography>
                    <PhoneInputField control={form.control} name="phone_number" />
                  </Grid>
                </Grid>
                <Grid>
                  <br />
                  <br />
                  <div ref={externalProfilesSecRef}  style={{ scrollMarginTop: '120px' }}></div>
                  <SectionTitle
                    id="external-profiles"
                    title="External Profiles"
                    subTitle=""
                    icon={<SocialMediaIcon height={'2.1875rem'} width={'2.1875rem'} />}
                  />
                  <br />
                </Grid>
                <Grid container xs={12} spacing={1}>
                  <Grid item xs={12}>
                    <Grid container alignItems="center" justify="space-between">
                      <Typography variant="h6" gutterBottom>
                        TMDB Person IDs
                      </Typography>

                      <IconButton
                        onClick={() => appendTMDB({ tmdb_id: '' })}
                        aria-label="add"
                        style={{ color: 'blue' }}>
                        <AddCircleOutline fontSize="large" />
                      </IconButton>
                    </Grid>

                    <Grid container style={{ display: 'flex', flexDirection: 'row' }}>
                      {tmdbFields.map((field, index) => {
                        const canDelete = tmdbFields.length > 1;

                        return (
                          <Grid
                            key={field.id}
                            container
                            spacing={2}
                            alignItems="center"
                            xs={3}
                            style={{
                              marginTop: 1,
                              padding: 1,
                              borderRadius: 1,
                            }}>
                            <Grid item xs={8}>
                              <ControlledTextField
                                control={form.control}
                                name={`tmdb_ids.${index}.tmdb_id`}
                                label={index === 0 ? 'Primary TMDB Person ID' : 'TMDB Person ID'}
                                fullWidth
                                variant="outlined"
                              />
                            </Grid>

                            <Grid item xs={2}>
                              {canDelete && (
                                <Tooltip title="Delete TMDB ID">
                                  <ColoredChipIconButton
                                    onClick={() => removeTMDB(index)}
                                    pointer
                                    colored={red[900]}
                                    size="small"
                                    icon={<TrashFill />}
                                  />
                                </Tooltip>
                              )}
                            </Grid>
                          </Grid>
                        );
                      })}
                    </Grid>
                  </Grid>
                  <Grid item xs={12}>
                    <Grid container alignItems="center" justify="space-between">
                      <Typography variant="h6" gutterBottom>
                        IMDB Person IDs
                      </Typography>

                      <IconButton
                        onClick={() => appendIMDB({ imdb_id: '' })}
                        aria-label="add"
                        style={{ color: 'blue' }}>
                        <AddCircleOutline fontSize="large" />
                      </IconButton>
                    </Grid>

                    <Grid container style={{ display: 'flex', flexDirection: 'row' }}>
                      {imdbFields.map((field, index) => {
                        const canDelete = imdbFields.length > 1;

                        return (
                          <Grid
                            key={field.id}
                            container
                            spacing={2}
                            alignItems="center"
                            xs={3}
                            style={{
                              marginTop: 1,
                              padding: 1,
                              borderRadius: 1,
                            }}>
                            <Grid item xs={8}>
                              <ControlledTextField
                                control={form.control}
                                name={`imdb_ids.${index}.imdb_id`}
                                label={index === 0 ? 'Primary IMDB Person ID' : 'IMDB Person ID'}
                                fullWidth
                                variant="outlined"
                              />
                            </Grid>

                            <Grid item xs={2}>
                              {canDelete && (
                                <Tooltip title="Delete IMDB ID">
                                  <ColoredChipIconButton
                                    onClick={() => removeIMDB(index)}
                                    pointer
                                    colored={red[900]}
                                    size="small"
                                    icon={<TrashFill />}
                                  />
                                </Tooltip>
                              )}
                            </Grid>
                          </Grid>
                        );
                      })}
                    </Grid>
                  </Grid>
                  <Grid item xs={12}>
                    <Grid container alignItems="center" justify="space-between">
                      <Typography variant="h6" gutterBottom>
                        HubSpot IDs
                      </Typography>

                      <IconButton
                        onClick={() =>
                          appendHubspot({
                            hubspot_id: '',
                          })
                        }
                        aria-label="add"
                        style={{ color: 'blue' }}>
                        <AddCircleOutline fontSize="large" />
                      </IconButton>
                    </Grid>
                    <Grid container style={{ display: 'flex', flexDirection: 'row' }}>
                      {hubspotFields.map((field, index) => {
                        const canDelete = hubspotFields.length > 1;

                        return (
                          <Grid
                            key={field.id}
                            container
                            spacing={2}
                            alignItems="center"
                            style={{
                              marginTop: 1,
                              padding: 1,
                              borderRadius: 1,
                            }}
                            xs={3}>
                            {/* HubSpot ID */}
                            <Grid item xs={8}>
                              <ControlledTextField
                                control={form.control}
                                name={`hubspot_ids.${index}.hubspot_id`}
                                label={index === 0 ? 'Primary HubSpot ID' : 'HubSpot ID'}
                                fullWidth
                                variant="outlined"
                              />
                            </Grid>

                            {/* Delete */}
                            <Grid item xs={2}>
                              {canDelete && (
                                <Tooltip title="Delete HubSpot ID">
                                  <ColoredChipIconButton
                                    onClick={() => removeHubspot(index)}
                                    pointer
                                    colored={red[900]}
                                    size="small"
                                    icon={<TrashFill />}
                                  />
                                </Tooltip>
                              )}
                            </Grid>
                          </Grid>
                        );
                      })}
                    </Grid>
                  </Grid>
                  <Grid item xs={6}>
                    <Typography variant="h6" gutterBottom>
                      LinkedIn URL
                    </Typography>
                    <ControlledTextField
                      fullWidth
                      variant="outlined"
                      name={'linkedin_url'}
                      label={'LinkedIn URL'}
                      control={form.control}
                      defaultValue={''}
                    />
                  </Grid>
                  <br />
                  <br />
                  <Grid item xs={6}>
                    <Typography variant="h6" gutterBottom>
                      Instagram URL
                    </Typography>
                    <ControlledTextField
                      fullWidth
                      variant="outlined"
                      name={'instagram_url'}
                      label={'Instagram URL'}
                      control={form.control}
                      defaultValue={''}
                    />
                  </Grid>
                  <br />
                  <br />
                  <Grid item xs={6}>
                    <Typography variant="h6" gutterBottom>
                      Facebook URL
                    </Typography>
                    <ControlledTextField
                      fullWidth
                      variant="outlined"
                      name={'facebook_url'}
                      label={'Facebook URL'}
                      control={form.control}
                      defaultValue={''}
                    />
                  </Grid>
                  <br />
                  <br />
                  <Grid item xs={6}>
                    <Typography variant="h6" gutterBottom>
                      X/Twitter URL
                    </Typography>
                    <ControlledTextField
                      fullWidth
                      variant="outlined"
                      name={'twitter_url'}
                      label={'Twitter URL'}
                      control={form.control}
                      defaultValue={''}
                    />
                  </Grid>
                  <br />
                  <br />
                  <br />
                  <Grid item xs={4}>
                    <Typography variant="h6" gutterBottom>
                      Home Page
                    </Typography>
                    <ControlledTextField
                      fullWidth
                      variant="outlined"
                      name={'home_page'}
                      label={'Home Page'}
                      control={form.control}
                      defaultValue={personMasterData?.home_page ? personMasterData?.home_page : ''}
                    />
                  </Grid>
                  <br />
                  <br />
                  <Grid item xs={4}>
                    <Typography variant="h6" gutterBottom>
                      Freebase
                    </Typography>
                    <ControlledTextField
                      fullWidth
                      variant="outlined"
                      name={'freebase_mid'}
                      label={'Freebase'}
                      control={form.control}
                      defaultValue={personMasterData?.freebase ? personMasterData?.freebase : ''}
                    />
                  </Grid>
                  <br />
                  <br />
                  <Grid item xs={4}>
                    <Typography variant="h6" gutterBottom>
                      TV Rage
                    </Typography>
                    <ControlledTextField
                      fullWidth
                      variant="outlined"
                      name={'tvrage_id'}
                      label={'TV Rage'}
                      control={form.control}
                      defaultValue={personMasterData?.tv_rage ? personMasterData?.tv_rage : ''}
                    />
                  </Grid>
                  <br />
                  <br />
                  <Grid item xs={4}>
                    <Typography variant="h6" gutterBottom>
                      Wikidata
                    </Typography>
                    <ControlledTextField
                      fullWidth
                      variant="outlined"
                      name={'wikidata_id'}
                      label={'Wikidata'}
                      control={form.control}
                      defaultValue={personMasterData?.wikidata ? personMasterData?.wikidata : ''}
                    />
                  </Grid>
                  <br />
                  <br />
                  <Grid item xs={4}>
                    <Typography variant="h6" gutterBottom>
                      TikTok
                    </Typography>
                    <ControlledTextField
                      fullWidth
                      variant="outlined"
                      name={'tiktok_url'}
                      label={'TikTok'}
                      control={form.control}
                      defaultValue={personMasterData?.tikTok ? personMasterData?.tikTok : ''}
                    />
                  </Grid>
                  <br />
                  <br />
                  <Grid item xs={4}>
                    <Typography variant="h6" gutterBottom>
                      YouTube
                    </Typography>
                    <ControlledTextField
                      fullWidth
                      variant="outlined"
                      name={'youtube_url'}
                      label={'YouTube'}
                      control={form.control}
                      defaultValue={personMasterData?.youTube ? personMasterData?.youTube : ''}
                    />
                  </Grid>
                  <br />
                  <br />
                </Grid>
                <Grid item xs={12}>
                  <br />
                  <br />
                  <div ref={badgeSecRef}  style={{ scrollMarginTop: '120px' }}>
                   <Grid item>
          <SectionTitle
            id="person-badges"
            title="Person Badges"
            subTitle="Information about Person Badges"
            icon={sectionIcon}
          />
        </Grid>
         <Divider />
              <br />
              <Grid container spacing={1}>
                <Grid item xs={12}>
                  <CompanyBadgesField control={control} name="person_badges" isLock={false} />
                </Grid>
              </Grid>
                  </div>
                </Grid>
                <Grid item xs={12}>
                  <br />
                  <br />
                  <div ref={sourcesSecRef}  style={{ scrollMarginTop: '120px' }}></div>
                  <SectionTitle
                    id="sources"
                    title="Sources"
                    subTitle=""
                    icon={<AccountTreeTwoToneIcon fontSize="large" style={{ color: green[600] }} />}
                  />
                  <br />
                  <br />
                </Grid>
                <Grid container xs={12} spacing={1}>
                  <Grid item xs={3}>
                    <Typography variant="h6" gutterBottom>
                      Sources
                    </Typography>
                    <ControlledSourceTextField
                      disabled
                      fullWidth
                      variant="outlined"
                      name={'datasource_id'}
                      label={'Source'}
                      control={form.control}
                      defaultValue={''}
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <br />
                    <br />
                    <Grid container justify="space-between" style={{ marginRight: '30px' }}>
                      <Grid item>
                        <SubSectionTitle
                          icon={
                            <HttpIcon
                              fontSize="large"
                              style={{
                                color: '#9be026',
                                background:
                                  'radial-gradient(square, rgba(2,0,36,1) 55%, rgba(255,255,255,1) 55%, rgba(255,255,255,1) 100%)',
                              }}
                            />
                          }
                          title="Source URLs"
                          subTitle="Additional URLs of sources"
                        />
                      </Grid>
                      <Grid item style={{ paddingBottom: '10px' }}>
                        <Tooltip title="Add IMDb details">
                          <StyledFab
                            disabled={false}
                            onClick={addAttributes}
                            color="primary"
                            aria-label="add"
                            size="small">
                            <AddIcon />
                          </StyledFab>
                        </Tooltip>
                      </Grid>
                    </Grid>
                    <Divider />
                    <br />
                    <fieldset disabled={false} style={{ border: 'none' }}>
                      <Grid
                        container
                        spacing={1}
                        justify="space-between"
                        // style={{ display: 'flex' }}
                        // key={indexOfAttribute}
                      >
                        {indexesAttributes.map((indexOfAttribute, i) => {
                          return socialAttrs.map((attr, i) => {
                            return (
                              <Grid
                                item
                                container
                                style={{ display: 'flex' }}
                                xs={6}
                                key={indexOfAttribute}>
                                <Grid item xs={10}>
                                  <CompanyBasicFormField
                                    {...attr}
                                    fullWidth
                                    name={`source_urls[${indexOfAttribute}]`}
                                    defaultValue={
                                      watchOnOtherSourceUrl
                                        ? watchOnOtherSourceUrl[indexOfAttribute]
                                        : ''
                                    }
                                  />
                                </Grid>
                                {indexesAttributes.length > 1 ? (
                                  <Grid item xs={2}>
                                    <div
                                      style={{
                                        marginTop: '10px',
                                        justifyContent: 'center',
                                        display: 'flex',
                                        marginRight: '20px',
                                      }}>
                                      <Tooltip title="Delete Atrribute">
                                        <ColoredChipIconButton
                                          onClick={() => removeAttributes(indexOfAttribute)}
                                          pointer
                                          colored={red[900]}
                                          size="small"
                                          icon={<TrashFill />}
                                        />
                                      </Tooltip>
                                    </div>
                                  </Grid>
                                ) : null}
                              </Grid>
                            );
                          });
                        })}
                      </Grid>
                    </fieldset>
                  </Grid>
                </Grid>
                <Grid>
                  <br />
                  <br />
                  <div ref={specializationSecRef}  style={{ scrollMarginTop: '120px' }}></div>
                  <SectionTitle
                    id="specialization"
                    title="Specialization"
                    subTitle=""
                    icon={<DescriptionRoundedIcon fontSize="large" style={{ color: amber[700] }} />}
                  />
                  <br />
                </Grid>
                <Grid container xs={12} spacing={1}>
                  <Grid item xs={12}>
                    <Typography variant="h6" gutterBottom>
                      Headline
                    </Typography>
                    <ControlledTextField
                      fullWidth
                      variant="outlined"
                      name={'headline'}
                      label={'Headline'}
                      control={form.control}
                      defaultValue={''}
                      multiline
                      rows={3}
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <Typography variant="h6" gutterBottom>
                      Expertise
                    </Typography>
                    <ControlledTextField
                      fullWidth
                      variant="outlined"
                      name={'expertise'}
                      label={'Expertise'}
                      control={form.control}
                      defaultValue={''}
                      multiline
                      rows={3}
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <Typography variant="h6" gutterBottom>
                      Biography
                    </Typography>
                    <ControlledTextField
                      fullWidth
                      variant="outlined"
                      name={'biography'}
                      label={'Biography'}
                      control={form.control}
                      defaultValue={''}
                      multiline
                      rows={8}
                    />
                  </Grid>
                </Grid>
              </Grid>
            </>
          )
        )}
      </ScrollSpyBoundry>
    </div>
  );
}

export const ControlledTextField = ({ name, control, ...props }) => {
  const {
    field: { value, onChange },
  } = useController({ name, control });
  const callbackOnChange = useCallback(e => onChange(e.target.value), [onChange]);
  return <TextField {...props} name={name} value={value || ''} onChange={callbackOnChange} />;
};
export const ControlledIdTextField = ({ name, control, ...props }) => {
  const { field } = useController({ name, control });

  return (
    <TextField
      {...props}
      {...field}
      value={field.value ?? ''}
      onChange={(e) => field.onChange(e.target.value)}
    />
  );
};

export const DateControlledTextField = ({ name, control, ...props }) => {
  const {
    field: { value, onChange },
  } = useController({ name, control, defaultValue: '' });
  const callbackOnChange = useCallback(e => onChange(e.target.value), [onChange]);
  return (
    <TextField
      {...props}
      name={name}
      value={convertToDateTimeFromISOString(value) || ''}
      onChange={callbackOnChange}
    /> 
  );
};

export const ControlledCheckbox = ({ name, control, label, ...props }) => {
  const {
    field: { value, onChange },
  } = useController({
    name,
    control,
    defaultValue: false, // Ensure the default value is a boolean for a checkbox
  });

  // Custom onChange to adapt the checkbox's `checked` state
  const callbackOnChange = useCallback(e => onChange(e.target.checked), [onChange]);
  return (
    <div
      style={{
        height: '100%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      }}>
      <Checkbox
        {...props}
        name={name}
        checked={value} // Ensure the value is treated as a boolean
        onChange={callbackOnChange}
      />
      <Typography style={{ marginBottom: 0 }} variant="h6" gutterBottom>
        {label}
      </Typography>
    </div>
  );
};

const ControlledSourceTextField = ({ name, control, ...props }) => {
  const {
    field: { value, onChange },
  } = useController({ name, control, defaultValue: '' });
  const callbackOnChange = useCallback(e => onChange(e.target.value), [onChange]);
  let source =
    value == 1001
      ? 'TMDB'
      : value == 2001
      ? ' OMDB'
      : value == 3001
      ? '  GVD '
      : value == 4001
      ? 'DELI'
      : value == 6001
      ? 'HubSpot'
      : 'N/A';
  return <TextField {...props} name={name} value={source || ''} onChange={callbackOnChange} />;
};
const ControlledStatusSelect = ({ name, control, ...props }) => {
  const {
    field: { value, onChange },
  } = useController({ name, control, defaultValue: false });

  const callbackOnChange = useCallback(
    (e) => onChange(e.target.value === "true"),
    [onChange]
  );

  return (
    <TextField
      select
      {...props}
      name={name}
      value={value ? "true" : "false"}
      onChange={callbackOnChange}
    >
      <MenuItem value="false">Active</MenuItem>
      <MenuItem value="true">Inactive</MenuItem>
    </TextField>
  );
};

const ControlledDataOwnerTextField = ({ name, control, ...props }) => {
  const {
    field: { value, onChange },
  } = useController({ name, control, defaultValue: '' });
  const callbackOnChange = useCallback(e => onChange(e.target.value), [onChange]);
  let source =
    value == 1001
      ? 'TMDB'
      : value == 2001
      ? ' OMDB'
      : value == 3001
      ? '  GVD '
      : value == 4001
      ? 'DELI'
      : value == 6001
      ? 'HubSpot'
      : 'N/A';
  return <TextField {...props} name={name} value={source || ''} onChange={callbackOnChange} />;
};
const ControlledNumberTextField = ({
  name,
  control,
  removeService = null,
  loadingBar = false,
  ...props
}) => {
  const {
    field: { value, onChange },
  } = useController({ name, control, defaultValue: '' });
  const callbackOnChange = useCallback(e => onChange(e.target.value), [onChange]);
  if (removeService) {
    return (
      <TextField
        {...props}
        name={name}
        value={value || ''}
        onChange={callbackOnChange}
        InputProps={{
          endAdornment: (
            <React.Fragment>
              {loadingBar ? (
                <>
                  <FacebookCircularProgress />
                </>
              ) : null}
              <InputAdornment position="end">
                <ClearIcon onClick={removeService} style={{ cursor: 'pointer' }} />
              </InputAdornment>
            </React.Fragment>
          ),
        }}
      />
    );
  } else {
    return <TextField {...props} name={name} value={value} onChange={callbackOnChange} />;
  }
};

const createAttr = (
  key: keyof PersonMaster,
  spaceOccupied: GridSize = 6,
  label: string = null,
  componentToShow: React.ReactNode = null
) => ({
  key,
  spaceOccupied,
  label: label ? label : startCase(key),
  component: componentToShow,
});

const useStyles = makeStyles({
  root: {
    width: '300px',
  },
  center: {
    textAlign: 'center',
  },
});

const useStylesFacebook = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      position: 'relative',
    },
    bottom: {
      color: theme.palette.grey[theme.palette.type === 'light' ? 200 : 700],
    },
    top: {
      color: '#1a90ff',
      animationDuration: '550ms',
      position: 'absolute',
      left: 0,
    },
    circle: {
      strokeLinecap: 'round',
    },
  })
);

function FacebookCircularProgress(props: CircularProgressProps) {
  const classes = useStylesFacebook();

  return (
    <div className={classes.root}>
      <CircularProgress
        variant="determinate"
        className={classes.bottom}
        size={20}
        thickness={4}
        {...props}
        value={100}
      />
      <CircularProgress
        variant="indeterminate"
        disableShrink
        className={classes.top}
        classes={{
          circle: classes.circle,
        }}
        size={20}
        thickness={4}
        {...props}
      />
    </div>
  );
}
const ControlledAutoCompleteField = ({
  name,
  control,
  removeService = null,
  loadingBar = false,
  defaultValue,
  ...props
}) => {
  const {
    field: { value, onChange },
  } = useController({ name, control, defaultValue });

  const [options, setOptions] = React.useState([]);
  const [loading, setLoading] = React.useState(false);

  useEffect(() => {
    getOptionsData();
  }, []);

  const getOptionsData = () => {
    rolesService
      .rolesSearch({})
      .pipe(
        map(res => ({
          ...res.data,
          data: res.data,
        }))
      )
      .subscribe({
        next: data => {
          setOptions(data.data);
        },
        error: data => {
          console.log(data, "Error");
        },
        complete: () => {
          setLoading(false);
        },
      });
  };

  return (
    <Autocomplete
      fullWidth
      value={value || null}
      defaultValue={defaultValue}
      onChange={(evt, v) => onChange(v)}
      options={options}
      getOptionLabel={(option) => option || ""}
      renderInput={(params) => (
        <TextField
          {...params}
          variant="outlined"
          label="Known For"
          placeholder="Select Known For"
          fullWidth
          inputProps={{ ...params.inputProps, readOnly: true }} 
        />
      )}
    />
  );
};
const StyledTable = styled.table`
  width: 100%;
  border-collapse: collapse;
  margin: 20px 0;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  border-radius: 8px;
  overflow: hidden; /* Ensure rounded corners work properly */
`;

const StyledTableHeader = styled.th`
  background-color: #f0f0f0;
  padding: 12px 15px;
  text-align: left;
  font-weight: 600;
  border-bottom: 1px solid #ddd;
`;

const StyledTableCell = styled.td`
  padding: 12px 15px;
  border-bottom: 1px solid #ddd;
`;

const StyledTableRow = styled.tr`
  &:nth-child(even) {
    background-color: #f9f9f9;
  }
`;

function C2PTable({ data }) {
  if (!data || data.length === 0) {
    return <p>No data to display.</p>;
  }

  const headerMapper = {
    company_name: 'Company',
    currently_working: 'Currently Working',
    designation: 'Designation',
    markets_responsible: 'Markets Responsible',
  };
  const headers = Object.keys(headerMapper);

  return (
    <StyledTable>
      <thead>
        <StyledTableRow>
          {headers.map(header => (
            <StyledTableHeader key={header}>{headerMapper[header]}</StyledTableHeader>
          ))}
        </StyledTableRow>
      </thead>
      <tbody>
        {data.map((row, index) => (
          <StyledTableRow key={row.company_vtr_id || index}>
            {headers.map(header => (
              <StyledTableCell key={`${row.company_vtr_id || index}-${header}`}>
                {header === 'company_name' ? (
                  <CommonCellForCompanyLogo
                    vtr_id={row?.company_vtr_id}
                    name={row?.company_name}
                  />
                ) : (
                  row[header] || '-'
                )}
              </StyledTableCell>
            ))}
          </StyledTableRow>
        ))}
      </tbody>
    </StyledTable>
  );
}
